// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"193c605b","453":"822bd1c5","455":"c50d65fc","977":"8339f93d"}[chunkId] + ".chunk.js";
};